import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarCheckIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function MobileCallBar() {
  const {
    t
  } = useLanguage();
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-navy-800 bg-navy-950/95 p-3 backdrop-blur sm:hidden" data-id="element-294" data-mp="2idfd6lr1mc1j">
      <a href={business.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md bg-gold-500 font-bold text-navy-950" data-id="element-295" data-mp="24kz7fd6rbzwx">
        <PhoneIcon width={18} height={18} aria-hidden="true" data-id="element-296" data-mp="1uqgyntmhhe69" />
        {t(copy.cta.callNow)}
      </a>
      <Link to="/contact" className="flex min-h-[48px] items-center justify-center gap-2 rounded-md border border-navy-700 font-bold text-white" data-id="element-297" data-mp="1zoif06siyze1">
        <CalendarCheckIcon width={18} height={18} aria-hidden="true" data-id="element-298" data-mp="1qnkc5rttoxx1" />
        {t(copy.cta.bookShort)}
      </Link>
    </div>;
}